import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import colors from 'src/utils/colors';

interface OmniCardViewSearchProps {
  style: React.CSSProperties;
  onSearch: (searchKey: string) => void;
}

const useStyles = makeStyles({
  searchInput: {
    borderBottom: `1px solid ${colors.borderGrey}`,
    width: '100%',
    borderRadius: 0
  },
  searchIcon: {
    color: colors.grey,
    opacity: 0.7,
    paddingRight: 5
  }
});

const OmniCardViewSearch: React.FC<OmniCardViewSearchProps> = ({ style, onSearch }: OmniCardViewSearchProps) => {
  const classes = useStyles();
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    onSearch(newValue);
  };
  return (
    <div style={style}>
      <TextField
        variant="standard"
        placeholder="Search for location"
        InputProps={{
          disableUnderline: true,
          style: {
            fontWeight: 500,
            fontSize: '18px'
          },
          startAdornment: <SearchIcon classes={{ root: classes.searchIcon }} />
        }}
        classes={{ root: classes.searchInput }}
        onChange={handleSearch}
      />
    </div>
  );
};

export default OmniCardViewSearch;
